<template>
  <div class="lun_sports_rank">
    <Row type="flex" class="myinfo" justify="spce-around" align="bottom">
      <Col span="9">
        <div class="myavatar">
          <VanImage :src="myinfo.avatar" />
        </div>
        <div class="myrank">
          <template v-if="+myinfo.rank > 0">排名 {{ myinfo.rank }}</template>
          <template v-else>暂无排名</template>
        </div>
      </Col>
      <Col span="9">
        <div
          style="padding-bottom: .2rem;font-weight: bold;font-size:.35rem;"
        >{{ myinfo.name || myinfo.nickname }}</div>
        <div>
          <!-- <div>{{ myinfo.register_type && '组别:' + myinfo.register_type }}</div> -->
          <div v-if="myinfo.score">得分:{{myinfo.score}}</div>
          <div v-else>尚未参加</div>
        </div>
      </Col>
    </Row>

    <List
      style="color:#FFF;"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getRankList"
    >
      <div class="rank-list">
        <CellGroup :style="`border-radius: ${borderRadius}`" v-if="rankList.length" :border="false">
          <Cell v-for="item in rankList" :key="item.id" center  class="rank">
             <div slot="title">{{item.nickname||item.name}}</div>
            <div slot="icon" class="rank_icon">
              <template v-if="item.rank <= 3">
                <img src="@/assets/img/rank/first.png" :alt="item.rank" v-if="item.rank == 1" />
                <img src="@/assets/img/rank/second.png" :alt="item.rank" v-if="item.rank == 2" />
                <img src="@/assets/img/rank/third.png" :alt="item.rank" v-if="item.rank == 3" />
              </template>

              <span v-else>{{ item.rank }}</span>
              <VanImage :src="item.avatarurl" />
            </div>
            <div
              slot="label"
              v-if="item.create_time"
            >{{ item.province || '-' }}</div>


            <template><span>{{ item.score*1 }} 分</span></template>

            <!-- {{ item.score*1 }} {{type|SportsItemtype}} -->
          </Cell>
        </CellGroup>
        <Empty
          style="background: #fff;min-height: 6rem"
          :style="`border-radius: ${borderRadius}`"
          v-else
          description="暂无数据"
        />
      </div>
    </List>
  </div>
</template>

<style lang="less" scoped>
@import "./rank.less";

.filter {
  width: 6.9rem;
  margin: 0 auto;
  display: flex;
  align-items: center;

  .item {
    font-size: 0.3rem;
    padding: 0.12rem 0;
    width: 2rem;
    display: flex;
    justify-content: center;
    border-radius: 0.2rem 0.2rem 0 0;

    &.active {
      background: #fff;
      color: #333;
    }
  }
}
</style>

<script>
import { Empty, Panel, Cell, CellGroup, Image, List, Row, Col } from "vant";
import moment from "moment";
export default {
  filters:{
    diffentTime(diffValue, Value) {
      if(!Value) return '- -'

      if (diffValue < 0) {
        console.log('时间不对劲,服务器创建时间与当前时间不同步');
        return '刚刚';
      }
      if (diffValue < 60) {
        return '刚刚';
      }
      let dur = moment.duration(diffValue * 1000);
      if (diffValue > 60 && diffValue < 3600) {
        return dur.minutes() + '分钟前';
      }

      if (diffValue > 3600 && diffValue < 86400) {
        return dur.hours() + '小时前';
      }
      return moment(Value * 1000).format('MM-DD HH:mm');
    },
    SportsItemtype(value){
      switch(+value){
        case 2:
          return '个';
          break;
        default:
          return '';
          break;
      }
    }
  },
  computed: {
    buttonColor() {
      let detail = this.detail;
      if (!detail) return "#ccc";
      return `${detail.tabstyle[0]["color"]}`;
    },
    borderRadius() {
        return "0 .2rem .2rem .2rem";
    },
  },
  components: {
    Empty,
    Panel,
    Cell,
    CellGroup,
    List,
    VanImage: Image,
    Row,
    Col,
  },
  data() {
    return {
      rankList: [],
      loading: false,
      finished: false,
      detail: "",
      page: 1,
      systime: "",
      myinfo: "",
      register_type: "",
      filter: [],
      type: "",
      physical_item_id: 0,
	  acid: ''
    };
  },
  methods: {
    getRankList: function () {
      //如果为空or 0 按照 item_id  rank
      this.$api.sports
        .questionRank({ acid: this.acid, page: this.page })
        .then((res) => {
            if (+res.status !== 200) {
              this.finished = true;
              return;
            }
            this.systime = res.sys_time;
            this.loading = false;
            let {
              list,
              page,
              pages,
              myinfo,
              type,
              physical_item_id,
            } = res.data;
            this.myinfo = myinfo;
            this.type = type;
            this.physical_item_id = physical_item_id;
            this.filter = res.data.filter;
            if (page == 1) {
              this.rankList = list;
            } else {
              this.rankList = this.rankList.concat(list);
            }

            let t = null

            this.rankList.forEach((item, index) => {
                if(t == null){
                    t =  item;
                    t.rank = index+1;
                }else{
                    var n = item;
                    if(n.score*1 == t.score*1){
                        n.rank = t.rank;
                    }else{
                          n.rank = index+1;
                    }
                    t = n;
                }
            })

            if (page >= pages) {
              this.finished = true;
            } else {
              this.page++;
            }
          });
    },
    init: function () {
    //   this.$toast.loading({
    //     duration: 0,
    //   });
    },
  },
  mounted() {
    this.acid = this.$route.params.acid
    this.init();
    // this.getRankList();
  },
};
</script>
